import {showErrorNotification, showSuccessNotification} from '../global/notifications';

export default function () {
    let $saveButton = $('.form-footer .k-button');
    if ($saveButton.length) {
        attachSaveEvent($saveButton);
    }
}

const attachSaveEvent = $saveButton => {
    $saveButton.click(function (event) {
        event.preventDefault();
        saveBaseAgendaAnswers()
            .then(response => showSuccessNotification(response))
            .catch(error => showErrorNotification());
    });
};
const saveBaseAgendaAnswers = () => new Promise((resolve, reject) => {
    let pid      = parseInt($('#Project_Pid').val()), question = {
        pid: pid
    }, finalized = $('#finalizeForm').prop('checked');

    //Set Finalized Attribute
    $('#Finalized').val(finalized);

    question.finalize = finalized;

    let url = '/Forms/ProjectReview/SaveBaseAgendaAnswers?pid=' + pid;
    let formData = $('#BaselineAgendaModelForm').serialize();

    $.post(url, formData, function (response) {
        response = response.split(':')[0];
        if (response === 'Success') {
            resolve();
            if (question.finalize) {
                $('#BaselineAgendaForm').load('/Forms/ProjectReview/ReloadBaselineAgendaForm', question);
            }
        } else if (response === 'Finalized') {
            //Reload page
            resolve('Form has already been Finalized by another User');
            $('#BaselineAgendaForm').load('/Forms/ProjectReview/ReloadBaselineAgendaForm', question);
        } else {
            reject();
        }
    });
});